import { render, staticRenderFns } from "./testall.vue?vue&type=template&id=4e14bbd0&"
import script from "./testall.vue?vue&type=script&lang=js&"
export * from "./testall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports